import { loginRequest } from "../../authConfig";
import logo from "/assets/logo-S0hqONVq.svg";
import css from "./Login.module.css";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import {
	fetchLogicsCommits,
	selectFetchBackendStatus,
} from "../../features/logics/logicsSlice";
import { useAppDispatch } from "../../app/hooks";

export function Login() {
	const { instance } = useMsal();
	const dispatch = useAppDispatch();
	const { t } = useTranslation();
	const reflistStatus = useSelector(selectFetchBackendStatus);

	const handleRedirect = () => {
		instance
			.loginPopup({
				...loginRequest,
				prompt: "create",
			})
			.then((response) => {
				if (response.account) {
					if (
						reflistStatus.code === "idle" ||
						reflistStatus.code === "failed"
					) {
						dispatch(fetchLogicsCommits());
					}
				}
			})
			.catch((error) => console.log(error));
	};

	return (
		<section
			className={css.sectionArea}
			style={{
				backgroundImage: logo,
			}}
		>
			<div className={css.backgroundDiv}>
				<div className={css.headerDiv}>
					<a href="/">
						<img
							src="/assets/logo-S0hqONVq.svg"
							style={{
								width: 300,
							}}
							alt="logo"
						/>
					</a>
				</div>
				<div className={css.loginDiv}>
					<div className={css.formDiv}>
						<div>
							<h1>Panda Configurator</h1>
						</div>
						<div>
							<button
								name="loginButton"
								className={css.buttonLogin}
								onClick={handleRedirect}
							>
								<img
									src="/assets/microsoft_logo.svg"
									style={{ height: "1.5em" }}
								/>
								<span>{t("signInMicrosoft")}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
